import gsap from "gsap";
import { Container, ContainerOptions, DestroyOptions, Sprite } from "pixi.js";

class Background extends Container {
  private image: Sprite;
  private rays: Container;
  private sprRays1: Sprite;
  private sprRays2: Sprite;
  private tl1: gsap.core.Timeline;
  private tl2: gsap.core.Timeline;

  private readonly topY: number = 0;
  private readonly bottomY: number;
  private curTimeline: gsap.core.Timeline | null = null;

  constructor(options?: ContainerOptions) {
    super(options);

    this.image = Sprite.from("jackpot-background");
    this.addChild(this.image);

    this.bottomY = -(this.image.height - 1080);

    this.rays = new Container();
    this.addChild(this.rays);
    this.sprRays1 = Sprite.from("jackpot-background-rays");
    this.sprRays1.anchor.set(0.5, 0);
    this.sprRays1.position.set(this.image.width / 2, -20);
    this.sprRays2 = Sprite.from("jackpot-background-rays");
    this.sprRays2.anchor.set(0.5, 0);
    this.sprRays2.scale.x = -1;
    this.sprRays2.position.set(this.image.width / 2, -20);

    this.rays.addChild(this.sprRays1, this.sprRays2);

    this.tl1 = gsap.timeline({
      repeat: -1,
      repeatRefresh: true,
    });

    this.tl1
      .to(this.sprRays1, {
        pixi: {
          rotation: Math.PI,
          alpha: 0.2,
        },
        ease: "sine.inOut",
        duration: 4,
      })
      .to(this.sprRays1, {
        pixi: {
          rotation: -Math.PI,
          alpha: 1,
        },
        ease: "sine.inOut",
        duration: 3,
      });

    this.tl2 = gsap.timeline({
      repeat: -1,
      repeatRefresh: true,
    });
    this.tl2
      .to(this.sprRays2, {
        pixi: {
          rotation: -Math.PI,
          alpha: 1,
        },
        ease: "sine.inOut",
        duration: 3,
      })
      .to(this.sprRays2, {
        pixi: {
          rotation: Math.PI,
          alpha: 0.2,
        },
        ease: "sine.inOut",
        duration: 5,
      });
    this.tl2.play(this.tl2.totalDuration() * 0.2);
  }

  public toTop = (duration?: number): gsap.core.Timeline | null => {
    if (this.curTimeline !== null) {
      this.curTimeline.kill();
    }

    if (this.y === this.topY) return null;

    if (duration === undefined) duration = 2;
    if (duration === 0) {
      this.y = this.topY;
    }

    const tl = gsap.timeline({
      onComplete: () => {
        if (this.curTimeline === tl) {
          this.curTimeline.kill();
          this.curTimeline = null;
        }
      },
    });

    tl.to(this, {
      pixi: {
        y: this.topY,
      },
      duration: duration,
      ease: "sine.inOut",
    });

    this.curTimeline = tl;
    return tl;
  };

  public toBottom = (duration?: number): gsap.core.Timeline | null => {
    if (this.curTimeline !== null) {
      this.curTimeline.kill();
    }

    if (this.y === this.bottomY) return null;

    if (duration === undefined) duration = 2;
    if (duration === 0) {
      this.y = this.bottomY;
    }

    const tl = gsap.timeline({
      onComplete: () => {
        if (this.curTimeline === tl) {
          this.curTimeline.kill();
          this.curTimeline = null;
        }
      },
    });

    tl.to(this, {
      pixi: {
        y: this.bottomY,
      },
      duration: duration,
      ease: "sine.inOut",
    });

    this.curTimeline = tl;
    return tl;
  };

  destroy(options?: DestroyOptions): void {
    super.destroy(options);
  }
}

export default Background;
